import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export const SmsConfirmDialog = ({
  open, onOpenChange, preview, title, description, busy,
  onConfirm, confirmLabel = "Send Text", footerExtra = null,
}) => {
  const p = preview || {};
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="sms-confirm-dialog" className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-1">
          <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm space-y-1.5">
            <div className="flex justify-between gap-3"><span className="text-slate-500">Recipient</span><span className="font-medium text-slate-800 text-right" data-testid="sms-recipient-name">{p.name || "—"}</span></div>
            <div className="flex justify-between gap-3"><span className="text-slate-500">Mobile</span><span className="font-mono-nums text-slate-800" data-testid="sms-recipient-phone">{p.phone || "—"}</span></div>
            {p.to && <div className="flex justify-between gap-3"><span className="text-slate-500">Send to</span><span className="font-mono-nums text-xs text-slate-600 break-all text-right" data-testid="sms-to-number">{p.to}</span></div>}
          </div>
          <div>
            <p className="text-xs uppercase tracking-wide text-slate-500 mb-1">Message preview</p>
            <div data-testid="sms-message-preview" className="rounded-lg border border-slate-200 bg-white p-3 text-sm text-slate-800 whitespace-pre-line">{p.message || ""}</div>
          </div>
          {!p.valid && p.reason && (
            <p data-testid="sms-invalid-reason" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{p.reason}</p>
          )}
          <p className="text-[11px] text-slate-400">Sent as an SMS via SMS Everyone to the tenant's mobile.</p>
        </div>
        <DialogFooter className="gap-2 flex-wrap">
          {footerExtra}
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="sms-cancel">Cancel</Button>
          <Button onClick={onConfirm} disabled={busy || !p.valid} data-testid="sms-send" className="bg-green-600 hover:bg-green-700">{busy ? "Sending..." : confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
